export default "/images/vendor/flag-icon-css/flags/1x1/tc.svg?7bce3122dd358a8489b57a7b44856c69";